module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_major/uma_lines-e8c41d49591eb8b18e82df2c8497a637.gif";